/**
 * Centralized date formatting utilities.
 * All functions accept an IANA timezone string (e.g. 'America/Los_Angeles').
 * Fallback is the system default from admin settings.
 */

export const fmtDate = (d, tz) => {
  if (!d) return '';
  try {
    const opts = { day: '2-digit', month: 'short', year: 'numeric' };
    if (tz) opts.timeZone = tz;
    return new Date(d).toLocaleDateString('en-GB', opts);
  } catch {
    return String(d);
  }
};

export const fmtDateTime = (d, tz) => {
  if (!d) return '';
  try {
    const opts = {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    };
    if (tz) opts.timeZone = tz;
    return new Date(d).toLocaleString('en-GB', opts);
  } catch {
    return String(d);
  }
};

export const fmtDateTimeFull = (d, tz) => {
  if (!d) return '';
  try {
    const opts = {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      timeZoneName: 'short',
    };
    if (tz) opts.timeZone = tz;
    return new Date(d).toLocaleString('en-GB', opts);
  } catch {
    return String(d);
  }
};

export const fmtDateOnly = (d, tz) => {
  if (!d) return '';
  try {
    const opts = { day: '2-digit', month: 'short', year: 'numeric' };
    if (tz) opts.timeZone = tz;
    return new Date(d).toLocaleDateString('en-GB', opts);
  } catch {
    return String(d);
  }
};
